<template>
    <div class="justify-content-center col-md-auto">
        <div class="d-flex ml-3">
            <div class="progress bluez mb-1"> 
                    <span class="progress-left"> <span class="progress-bar"></span> </span> 
                    <span class="progress-right"> <span class="progress-bar"></span> </span>
                <div class="progress-value">{{ progress }}</div>
            </div>
            <div class="mt-2"> 
                    <div class="mt-2 ml-2 d-flex">
                        <div class="gender-space"><div class="male"></div></div>
                        <div class=" text-menu-shadow">Rüden</div>
                    </div>
                    <div class="mt-2 ml-2 d-flex">
                        <div class="gender-space"><div class="female"></div></div>
                        <div class=" text-menu-shadow">Hündinnen</div>
                    </div>
            </div>
        </div>
        <div class="text-menu-shadow text-left">{{ caption }}</div> 
    </div>
</template>

<script>
// import _throttle      from 'lodash/throttle';
// import _get           from 'lodash/get';
import _isPlainObject from 'lodash/isPlainObject';

export default {
    components : {      
    },
     props: {
        progress: {
            type    : Number,
            required: true,
        },
        caption: {
            type    : String,
            required: true,
        },
    },
    computed: {},
    watch: {},
    methods: {},
    created(){},
    mounted(){
        // ...init javascript on vue-creation...
    }
}
</script>

<style lang="scss" scoped>


.yellow{
    color: #fdba04;
}
.progress {
    width: 70px;
    height: 70px !important;
    float: left;
    line-height: 150px;
    background: none;
    // margin: 200px;
    box-shadow: none;
    position: relative
}

.progress:after {
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 5px solid #e222ff;
    position: absolute;
    top: 0;
    left: 0
}

.progress>span {
    width: 50%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    z-index: 1
}

.progress .progress-left {
    left: 0
}

.progress .progress-bar {
    width: 100%;
    height: 100%;
    background: none;
    border-width: 5px;
    border-style: solid;
    position: absolute;
    top: 0
}

.progress .progress-left .progress-bar {
    left: 100%;
    border-top-right-radius: 80px;
    border-bottom-right-radius: 80px;
    border-left: 0;
    -webkit-transform-origin: center left;
    transform-origin: center left
}

.progress .progress-right {
    right: 0
}

.progress .progress-right .progress-bar {
    left: -100%;
    border-top-left-radius: 80px;
    border-bottom-left-radius: 80px;
    border-right: 0;
    -webkit-transform-origin: center right;
    transform-origin: center right;
    animation: loading-1 1.8s linear forwards
}

.progress .progress-value {
    width: 90%;
    height: 90%;
    border-radius: 50%;
    background: #ffffff;
    font-weight: bold;
    font-size: 13px;
    color: #000000;
    line-height: 70px;
    text-align: center;
    position: absolute;
    top: 5%;
    left: 5%
}

.progress-bar {
    border-color: #278fdf
}

.progress.bluez .progress-left .progress-bar {
    animation: loading-2 1.5s linear forwards 1.8s
}

.progress.yellow .progress-bar {
    border-color: #fdba04
}

.progress.yellow .progress-right .progress-bar {
    animation: loading-3 1.8s linear forwards
}

.progress.yellow .progress-left .progress-bar {
    animation: none
}

@keyframes loading-1 {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    100% {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg)
    }
}

@keyframes loading-2 {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    100% {
        -webkit-transform: rotate(144deg);
        transform: rotate(144deg)
    }
}

@keyframes loading-3 {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    100% {
        -webkit-transform: rotate(135deg);
        transform: rotate(135deg)
    }
}

.male{
    background-color: #278fdf;
    width: 15px;
    height: 3px;
}

.female{
    background-color: #e222ff;
    width: 15px;
    height: 3px;
}

.gender-space{
    margin-right: 10px;
    margin-top: 6px;
}
</style>
